import { useEffect, useState } from "react";
import axios from "axios";
import TicketTable from "./TicketTable";

export default function TicketDashboard() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await axios.get("/server/ticket_functions/getticketdetails");
        setTickets(response.data.data);
      } catch (error) {
        console.error("Error fetching tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, []);

  const openTickets = tickets.filter(d => d.Ticket_details.status === "Open");
  const inProgressTickets = tickets.filter(d => d.Ticket_details.status === "In Progress");
  const closedTickets = tickets.filter(d => d.Ticket_details.status === "Closed");

  if (loading) return  <div className="fixed inset-0 flex items-center justify-center bg-white/60 z-[9999]">
  <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
</div>;

  return (
    <div className="p-4 space-y-6">
      <TicketTable title="🟢 Open Tickets" data={openTickets} />
      <TicketTable title="🟡 In Progress Tickets" data={inProgressTickets} />
      <TicketTable title="🔴 Closed Tickets" data={closedTickets} />
    </div>
  );
}
